import React from 'react';
import { createTheme, ThemeProvider, Theme, StyledEngineProvider } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface TypeBackground {
    login: string;
  }
}

function MaterialUiTheme({ children }: { children: React.ReactNode }) {
  const theme: Theme = createTheme({
    palette: {
      background: {
        login: '#f3f3f3',
        default: '#f3f3f3',
      },
      primary: {
        main: '#2d3241',
        light: '#565b6c',
        dark: '#040a1b',
        contrastText: '#fff',
      },
      secondary: {
        main: '#eaeaea',
        light: '#ffffff',
        dark: '#b8b8b8',
        contrastText: '#000',
      },
    },
  });
  // eslint-disable-next-line no-console
  process.env.REACT_APP_ENV !== 'test' && console.log(theme);
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </StyledEngineProvider>
  );
}

export default MaterialUiTheme;
